import i18next from 'i18next'
import { t } from '$i18n'

export const toLocale = (
  text?: string | number,
  useGrouping = true,
  minimumIntegerDigits?: number,
) => {
  if (text == undefined) return ''

  if (typeof text === 'number')
    return text.toLocaleString(i18next.language, {
      useGrouping,
      minimumIntegerDigits,
    })
  if (typeof text === 'string') {
    return text.replace(/\d/g, num =>
      parseInt(num, 10).toLocaleString(i18next.language, {
        useGrouping,
        minimumIntegerDigits,
      }),
    )
  }

  return text
}

export const toFormattedPersianNumber = (number: string) => {
  const startsWithZero = number.startsWith('0')
  const startsWithPlus = number.startsWith('+98')
  const arr = startsWithZero
    ? number.split('').splice(1)
    : startsWithPlus
      ? number.split('').splice(3)
      : number.split('')
  const prefix = startsWithZero ? '0' : startsWithPlus ? '+98' : ''

  if (arr.length < 4) {
    return number
  }
  if (arr.length < 7) {
    return `${prefix}${arr.slice(0, 3).join('')} ${arr.slice(3, 6).join('')}`
  }
  return `${prefix}${arr.slice(0, 3).join('')} ${arr
    .slice(3, 6)
    .join('')} ${arr.slice(6).join('')}`
}

export function splitByFirst(str: string, char: string) {
  const charIndex = str.indexOf(char)
  return [str.slice(0, charIndex), str.slice(charIndex + 1)]
    .map(s => s.trim())
    .filter(Boolean)
}

// arabic and persian
const ar = '٠١٢٣٤٥٦٧٨٩۰۱۲۳۴۵۶۷۸۹'.split('')
const en = '01234567890123456789'.split('')
// TODO #optimize
export const toEnglishNumber = (strNum: string) => {
  return strNum
    .replace(/[٠١٢٣٤٥٦٧٨٩۰۱۲۳۴۵۶۷۸۹]/g, x => en[ar.indexOf(x)])
    .replace(/\D/g, '')
}

export const toEnglishPhoneNumber = (str: string) => {
  return str.replace(/[٠١٢٣٤٥٦٧٨٩۰۱۲۳۴۵۶۷۸۹]/g, x => en[ar.indexOf(x)])
}

export const formatViews = (views: number) => {
  // TODO: Can use: (needs some change)
  /* (views).toLocaleString('fa-IR', { maximumFractionDigits: 1, notation: 'compact', compactDisplay: 'long'}) */

  const { postfix, divider }: { postfix: string; divider?: number } =
    views >= 1000000000
      ? { postfix: t('common.billion'), divider: 1000000000 }
      : views >= 1000000
        ? { postfix: t('common.million'), divider: 1000000 }
        : views >= 1000
          ? { postfix: t('common.thousand'), divider: 1000 }
          : { postfix: null }

  if (!postfix) return { shortenedViews: toLocale(views) }

  const [intPart, decimalPart] = String(views / divider).split('.')
  const hasDecimal = !!decimalPart && decimalPart[0] > '0'

  const maxPrecisedViews = `${toLocale(Number(intPart))}${
    hasDecimal ? `.${toLocale(decimalPart[0])}` : ''
  }`

  return { shortenedViews: maxPrecisedViews, postfix }
}

export function patternMatching(expression: string, query: string) {
  return expression.toLowerCase().includes(query.toLowerCase())
}

export function areEqualStr(
  a: string | undefined | null,
  b: string | undefined | null,
) {
  if (!a && !b) return true
  return a === b
}
